var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_3595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916992 10.5C0.916992 5.18426 5.43145 0.875 11.0003 0.875C16.5692 0.875 21.0837 5.18426 21.0837 10.5C21.0837 15.8157 16.5692 20.125 11.0003 20.125C5.43145 20.125 0.916992 15.8157 0.916992 10.5Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.868 7.0376C16.226 7.37931 16.226 7.93333 15.868 8.27503L10.1781 13.9625C9.82015 14.3042 9.23975 14.3042 8.88177 13.9625L6.13177 11.3375C5.77379 10.9958 5.77379 10.4418 6.13177 10.1001C6.48975 9.75839 7.07015 9.75839 7.42813 10.1001L9.52995 12.1064L14.5716 7.0376C14.9296 6.69589 15.51 6.69589 15.868 7.0376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_3595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNotAvailable);
export default __webpack_public_path__ + "static/media/checkNotAvailable.c765f3526366a7d77ca38e792a069e5d.svg";
export { ForwardRef as ReactComponent };